import { useCallback } from 'react';

import { saveAs } from 'file-saver';
import { getFontEmbedCSS, toPng } from 'html-to-image';

import type { Options } from 'html-to-image/src/types';

const useScreenshot = () => {
    const generatePng = useCallback(
        async (ref: HTMLElement, name: string, options: Options = {}) => {
            if (ref === null) {
                return;
            }
            try {
                const fontEmbedCSS = await getFontEmbedCSS(ref);
                const screenShot = await toPng(ref, {
                    ...options,
                    fontEmbedCSS,
                    includeQueryParams: true
                });
                saveAs(screenShot, `${name ?? 'export'}.png`);
            } catch (error) {
                console.error(error);
            }
        },
        []
    );

    return { generatePng };
};

export default useScreenshot;
